import { ref, inject, computed } from 'vue';
import { I18nInjectionKey } from 'vue-i18n';
import AgreementLicenseAPI from '@/apis/eTask/agreementLicenseAPI.js';
import store from '@/stores/store';
import popupUtil from '@/commons/popupUtil.js';
import { MSEnum } from '@/commons/enumeration';
import { ModuleTourGuide } from '@/stores/moduleConst.js';


export const useAgreementLicense = () => {
  /**
     * Thông tin người dùng
     */
  const userInfo = store.state?.context?.User;

  /**
 * check xem thỏa thuận đã được xác nhận hay chưa
 */
  const checkAgreementLicense = () => {
    var nameParts = userInfo.FullName.split(' ');
    var lastName = nameParts.pop(); 
    var firstName = nameParts.join(' ');

    let param = {
      misaidKey: userInfo.MISAID,
      phoneNumber: userInfo.Mobile,
      email: userInfo.Email,
      lastName: lastName,
      firstName: firstName
    };

    AgreementLicenseAPI.checkAgreementApp(param).then((res) => {
      if (
        res?.AgreementsUri
      ) {
        popupUtil.show('PopupAgreementLicense', res)
      } else {
        getTourGuideConfig();
      }
    });
  }

  /**
   * Lấy lịch sử thỏa thuận sử dụng
   * @param {*} agreementType 
   * @returns 
   */
  const getAgreementsHistory = async(agreementType) => {
    let param = {
      misaidKey: userInfo.MISAID,
      phoneNumber: userInfo.Mobile,
      email: userInfo.Email,
      userID: userInfo.UserID,
      agreementType: agreementType,
      budgetCode: userInfo.OrganizationUnitCode
    };
    if (agreementType === MSEnum.AgreementType.Agreements) {
      param = { 
        agreementType: agreementType,
        budgetCode: userInfo.OrganizationUnitCode
      }
    }
    let res = await AgreementLicenseAPI.getAgreementsHistory(param)
    return res;
  }

  /**
   * Thực hiện trả về config tourGuide
   */
  const getTourGuideConfig = async () => {
    await store.dispatch(`tourGuide/checkTourGuideUpdate`);

    if (!store.state['tourGuide']?.tourGuideUpdate) {
      popupUtil.show('PopupTourGuide', {
        function() {
        },
      });
    }


    if (userInfo?.IsAdmin && store.state['tourGuide']?.tourGuideUpdate) {
      await store.dispatch(`${ModuleTourGuide}/getTourGuideConfig`);
    }

  }

  return { checkAgreementLicense, getAgreementsHistory, getTourGuideConfig };
}
